<template>
  <div class="flex items-center">
    <dropdown-chevron
      :is-open="model.open"
      :class="{ invisible: !model.backups?.length }"
    />
    <div
      class="h-3 w-3 rounded-xs border-0"
      :style="{
        backgroundColor:
          model.color ??
          SCORECARD_COLOR_SWATCHES[
            model.index % SCORECARD_COLOR_SWATCHES.length
          ],
      }"
    />
    <p class="px-3">{{ model.attribute }}</p>
    <div
      v-if="model.info"
      v-tooltip="{ content: model.info, placement: 'right' }"
    >
      <icon-base :icon="IconInfo" />
    </div>
    <div
      v-if="model.backup || model.backup_applied"
      class="ml-3 rounded-sm border border-gray-700 px-1 text-xxxs uppercase"
    >
      {{
        $t(
          model.backup_applied
            ? "SCORECARDS.BACKUP_APPLIED"
            : "SCORECARDS.BACKUP"
        )
      }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { SCORECARD_COLOR_SWATCHES } from "@/helpers/constants";

import IconInfo from "@/components/icons/IconInfo.vue";

import type { ScorecardGroupCategoryForPreview } from "@/models/scorecards";
import type { PropType } from "vue";

defineProps({
  model: {
    type: Object as PropType<ScorecardGroupCategoryForPreview>,
    required: true,
  },
});
</script>
